import React, {memo} from "react";
import {NodeProps} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {CompactUnit, formatCompactNumber, formatPercentage} from "@/utils/format.ts";
import {NodeData} from "@/pages/mindmap/type";

interface Props {
    data: NodeData;
}



export const RegionNode = memo(({data}: Props) => {
    const node: TreeNode = data.node;
    const parentNode: TreeNode = data.parentNode;
    const datas: Record<string, Metric> = node.metrics_map || {};

    const find_brother = (name:string) => {
        return parentNode.children?.filter((child) => child.name !== node.name)[0];
    }
    const render_vs_span = () => {
        let datas: Record<string, Metric> = {}
        let tmp_m:Metric[] = []
        const is_bm = node.id.endsWith("-broad")
        tmp_m = find_brother(is_bm?"Broad":"Core")?.metrics || []
        datas = {...tmp_m.reduce((acc, cur) => ({...acc, [cur.metric_name]: cur}), {})}

        const ele = <span style={get_color(`ims_mtd_vol_growth`, datas)}>
                {formatPercentage(datas[`ims_mtd_vol_growth`]?.value, 1)}
        </span>
        const txt = node.id.endsWith("-broad") ? "Core" : "BM";
        return <>(vs {txt} {ele})</>
    }

    const prefix = node.id.endsWith("-broad") ? "bm" : "core";


    const render_line_local = (
        l1: string,
        l2: string, datas: Record<string, Metric>,
        is_plan: boolean = false,
        targetUnit: CompactUnit = 'M'
    ) => {
        // 拼接指标key的时候有的中间需要这个 amt，有的不需要,
        // const middle_amt = l1 == "nts" ? 'amt_' : '';
        let vol_gro_key = `${l1}_${l2}_vol_growth`
        if (l1 == "nts") {
            vol_gro_key = `${l1}_amt_${l2}_vol_growth`
        }
        if (is_plan) {
            // vol_gro_key="ims_amt_mtd_vol_growth_mip"
            vol_gro_key = "ims_mtd_vol_growth"
            if (formatPercentage(datas[vol_gro_key]?.value) == "--") {
                vol_gro_key = "ims_amt_mtd_vol_growth"
            }
        }

        return <div>
            {/*特殊类型处理 ims_vbp 变为 vbp  ims_vbp_amt_mtd*/}
            <span>{l2.toUpperCase()} {l1.replace("ims_", "").toUpperCase().replace("NONVBP", "Non-Vbp")} </span>
            <span style={get_color(`${l1}_amt_${l2}`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}`]?.value, 1, targetUnit)}</span>
            <span>, Gap </span>
            <span style={get_color(`${l1}_amt_${l2}_gap`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}_gap`]?.value, 1, targetUnit)}
            </span>
            <span>, Achi </span>
            <span style={get_color(`${l1}_amt_${l2}_achi`, datas)}>
                {formatPercentage(datas[`${l1}_amt_${l2}_achi`]?.value)}
            </span>
            <span>, <br/>Vol Gro </span>
            <span style={get_color(vol_gro_key, datas)}>
                {formatPercentage(datas[vol_gro_key]?.value)}
            </span>
            &nbsp;
            {render_vs_span()}
        </div>
    }
    return <BasicCardNode node={node} showChart={true} data={data}>
        <div style={{marginLeft: '10px'}}>
            {render_line_local('ims', 'mtd', datas)}
            {(datas['ims_amt_mtd_gap']?.value ?? 0) < 0 &&
                <div style={{marginTop: '5px'}}>
                    <span>Top 5 underperforming hospitals account for </span>
                    <span style={get_color(`${prefix}_top5_gap_pct`, datas)}>
                    {formatPercentage(datas[`${prefix}_top5_gap_pct`]?.value, 1)}
                </span>
                    <span> of the<br/> total gap.</span>
                </div>
            }

        </div>
    </BasicCardNode>

})